<template>
    <div class="container">
        <div class="text-wrapper" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible-once="{
                opacity: 1,
                y: 0,
            }">
            <p class="contact">Certificates</p>
            <p class="title">Certifications I've Earned</p>
            <p class="description">A collection of courses and programs I've completed along the way.</p>
        </div>
        <div class="cards-wrapper" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible-once="{
                opacity: 1,
                y: 0,
            }">
            <div class="platform-card" v-for="certificate in certificates">
                <div class="card-header" :class="{ 'no-image': !certificate.image }">
                    <img v-if="certificate.image" :src="certificate.image" alt="">
                    <p v-else class="issuer-fallback">{{ certificate.issuer }}</p>
                </div>
                <div class="card-body">
                    <div class="content-wrapper">
                        <p class="title-text">{{ certificate.title }}</p>
                        <p class="description">{{ certificate.issuer }}<span v-if="certificate.date"> &middot; {{ certificate.date }}</span></p>
                    </div>
                    <a :href="certificate.url" target="_blank" rel="noopener" class="link">View Certificate</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'CertificatesComponent',
    data() {
        return {
            certificates: [
                {
                    title: 'Fidelity Generative AI',
                    issuer: 'Udacity',
                    image: require('@/assets/images/Udacity-GenAI-certificate.png'),
                    date: 'Jun 2026',
                    url: 'https://www.udacity.com/certificate/e/c689fa1c-fc59-11f0-b20d-9b0af6b70189'
                },
                {
                    title: 'Problem Solving (Intermediate)',
                    issuer: 'HackerRank',
                    image: require('@/assets/images/Hackerrank-problem-solving.png'),
                    date: 'Sep 2022',
                    url: 'https://www.hackerrank.com/certificates/9eb5b1189448'
                }
            ]

        };
    },
    components: {

    },
    computed: {

    },
    methods: {

    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px;
    display: flex;
    gap: 2rem;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.text-wrapper {
    display: flex;
    gap: 12px;
    flex-direction: column;
    text-align: center;
}

.contact {
    font-size: 1.5rem;
    font-weight: 600;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-text-color);
}

.description {
    font-size: 1rem;
    color: var(--secondary-text-color);
}

.cards-wrapper {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    justify-content: center;
}

.platform-card {
    width: 375px;
    display: flex;
    flex-direction: column;
    border: 1px solid #252626;
    border-radius: 20px;
    overflow: hidden;
    min-height: 320px;
    transition: all 0.3s ease-in-out;
}

.platform-card:hover {
    box-shadow: 6px 5px 8px #B66BE1;
    transform: scale(1.05);
}

.card-header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0E141E;
    height: 12.5rem;
    flex-wrap: wrap;
}

.card-header img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 0.5rem;
}

.card-header.no-image {
    background: linear-gradient(134.15deg, #B66BE1 24.79%, #FF6267 44.2%, #FFA84B 69.43%);
}

.issuer-fallback {
    font-size: 1.5rem;
    font-weight: 600;
    color: #0C0C0D;
}

.link {
    color: #2EC866;
}

.card-body {
    background-color: #0C0C0D;
    padding: 1rem 1.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.5rem;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.title-text {
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--primary-text-color);
}

@media (max-width: 900px) {

    .title {
        font-size: 2rem;
    }

    .container {
        padding: 3.5rem;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 2rem;
    }

    .text-wrapper {
        text-align: left;
        gap: 10px;
    }

    .contact, .description, .title-text {
        font-size: 0.9rem;
    }

    .title {
        font-size: 1.2rem;
    }

    .card-body {
        padding: 1rem;
    }
}
</style>
